// extracted by mini-css-extract-plugin
module.exports = {"app":"App__app___NghkZ"};